import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Formik } from 'formik';
import { ccIntl } from 'helpers/intl-helper';
import { Button } from '@companycam/slab-web';

const { formatMessage } = ccIntl;

const toggleOff = formatMessage({
  id: 'Common.toggleOff',
});
const toggleOn = formatMessage({
  id: 'Common.toggleOn',
});

const ConfigurationModal = ({ isSingleVideo, onSubmit }) => {
  const initialValues = {
    include_details: false,
  };
  return (
    <Formik onSubmit={onSubmit} initialValues={initialValues}>
      {({ values, errors, handleChange, handleSubmit, isSubmitting }) => {
        return (
          <form onSubmit={handleSubmit}>
            {errors.base ? (
              <div className="error-message">{errors.base}</div>
            ) : null}
            <div className="photo-options-on-off">
              <ul className="tg-list">
                <li className="tg-list-item">
                  <input
                    className="tgl tgl-light"
                    id="include_details"
                    type="checkbox"
                    name="include_details"
                    checked={values.include_details}
                    onChange={handleChange}
                  />
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <label
                    className="tgl-btn"
                    htmlFor="include_details"
                    data-off-label={toggleOff}
                    data-on-label={toggleOn}
                  />
                </li>
                <li
                  className="left-align-instructions"
                  data-testid="share-modal__instructions"
                >
                  <FormattedMessage
                    id="Galleries.configuration.instructions"
                    defaultMessage="Include who, when, and where the photo was taken."
                    description="Label describing the adjacent toggle input"
                  />
                </li>
              </ul>
            </div>
            <div className="btn-container full">
              <Button
                color="primary"
                type="submit"
                disabled={isSubmitting}
                data-testid="share-modal__button-submit"
              >
                {isSingleVideo ? (
                  <FormattedMessage
                    id="Galleries.configuration.video.submit"
                    defaultMessage="Get Link to Video"
                    description="Button that allows the user to get a link to their video"
                  />
                ) : (
                  <FormattedMessage
                    id="Galleries.configuration.submit"
                    defaultMessage="Get Link to Gallery"
                    description="Button that allows the user to get a link to their gallery"
                  />
                )}
              </Button>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};

ConfigurationModal.propTypes = {
  isSingleVideo: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

export default ConfigurationModal;
